import React from 'react';
import StyledToolbar, { StyledLogo } from 'components/toolbar/StyledToolbar';

const Toolbar = () => {
    return (
        <StyledToolbar>
            <StyledLogo />
        </StyledToolbar>
    );
};

export default Toolbar;
